module.exports = __webpack_public_path__ + "static/media/carouselBackground.1ffc91d8.png";